import {ReduxStateType} from '../store';

export const selectDocuments = (state: ReduxStateType) => {
  return state.documents;
};

export const selectDocument = (state: ReduxStateType, docId: number) => {
  return state.documents.documents.find((doc) => doc.docId === docId);
};
